import "./Home.module.css";
import ToppmenyOchKontakt from "@/reusable_sections/Header";
import MasterYourChannelStatistics from "./sections/MasterYourChannelStatistics";
import WhatExactlyIsARobotaxi from "./sections/WhatExactlyIsARobotaxi";
import LeadersInSelfDriving from "./sections/LeadersInSelfDriving";
import PathToSwedishApproval from "./sections/PathToSwedishApproval";
import WhyRobotaxiChangesEverything from "./sections/WhyRobotaxiChangesEverything";
import StayUpdated from "./sections/StayUpdated";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <meta name="google-site-verification" content="nniysS3D-3u6OQPky2RX2tPFzreMLoOygt147lvmZIU" />
      <ToppmenyOchKontakt />
      <MasterYourChannelStatistics />
      <WhatExactlyIsARobotaxi />
      <LeadersInSelfDriving />
      <PathToSwedishApproval />
      <WhyRobotaxiChangesEverything />
      <StayUpdated />
      <Footer />
    </div>;
}